import { Routes } from '@navigation';
import { mc } from '@styles';
import React from 'react';
import CookieConsent from 'react-cookie-consent';

export const CookiePolicy = () => {
  return (
    <CookieConsent
      disableStyles
      containerClasses={mc(
        'fixed z-50 left-8 sm:left-auto right-8 bottom-8 rounded border border-light-gray sm:max-w-[400px] sm:w-full',
        'p-6',
        'bg-white',
      )}
      buttonWrapperClasses="mt-8 flex flex-row justify-start items-center"
      declineButtonClasses={mc(
        'block px-6 sm:px-8 py-2 sm:py-3',
        'text-center font-raleway leading-normal font-semibold text-ocean-blue',
        'bg-white rounded-full border border-ocean-blue',
      )}
      buttonClasses={mc(
        'block px-6 sm:px-8 py-2 sm:py-3 ml-4',
        'text-center font-raleway leading-normal font-semibold text-white',
        'bg-salmon rounded-full',
      )}
      cookieName="cookiesConsent"
      location="none"
      expires={150}
      enableDeclineButton
      buttonText="Accept All"
      declineButtonText="Reject All"
    >
      <h4 className={mc('p-0 m-0', 'text-xl font-raleway leading-normal font-bold text-ocean-blue')}>Cookies</h4>
      <p className={mc('mt-2', 'font-raleway leading-normal font-medium text-ocean-blue')}>
        We use our own and third-party cookies to personalize content and to analyze web traffic.
      </p>
      <p className={mc('mt-8')}>
        <a className="font-raleway leading-normal font-semibold text-ocean-blue underline" href={Routes.privacyPolicy.url}>
          Read More
        </a>
      </p>
    </CookieConsent>
  );
};

export default CookiePolicy;
